import React from 'react';
import {Text} from "@chakra-ui/react";

const H1 = ({children, ...props}) => {
    return (
        <Text as={"h1"} pt={"16px"} mt={"-16px"} fontSize={{base: "lg", md: "xl", lg: "2xl"}} fontWeight={"bold"} {...props}>
            {children}
        </Text>
    );
};

export default H1;